import React, { useEffect, useMemo, useState } from 'react';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import BrandContainerWithLogo from '../Common/BrandContainerWithLogo';
import useLandingStore from '../../Store/Landing';

// import CreditsStatus from './CreditsStatus';
import CreditsList from './CreditsList';
import CreditCard from './CreditCard';
import Button from '../Common/Button';
import { StyledFilter } from './style';
import Icon from '../Common/Icon';
import { useTranslation } from 'react-i18next';
import ActionSheet from '../Common/ActionSheet';
import RadioGroup from '../Common/RadioGroup';
import { sortOptions } from '../../Utils/credits.util';
import { useNavigate, useParams } from 'react-router';
import useCreditsStore from '../../Store/Credits';
import { useLocation } from 'react-router-dom';
import { getQueryParams } from '../../Utils/common.util';
import SearchInput from '../Common/SearchInput';
const Credits: React.FC = () => {
  const landingData = useLandingStore((state) => state.landingData);
  const landingLoading = useLandingStore((state) => state.landingLoading);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const branchIdParam = getQueryParams(location.search)?.branchId;

  const setDataLength = useCreditsStore((state) => state.setDataLength);

  const [selectedBranch, setSelectedBranch] = useState(undefined);
  const [selectedSort, setSelectedSort] = useState(null);
  const [openSortActionSheet, setOpenSortActionSheet] = useState(false);
  const [openBranchesActionSheet, setOpenBranchesActionSheet] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const handleBranchChange = (value) => {
    setDataLength(10);
    setSelectedBranch(value);
    setSearchValue('');
    setOpenBranchesActionSheet(false);
    // Update URL with new branch selection (using clubBranchId)
    if (value.value === landingData.branchId) {
      // All branches - remove query param
      navigate('/credits', { replace: true });
    } else {
      navigate(`/credits?branchId=${value.value}`, { replace: true });
    }
  };

  const branches = useMemo(() => {
    if (!landingData?.clubLinkBranchInfoViewModels) return [];
    const x = landingData.clubLinkBranchInfoViewModels.map((item) => ({
      label: item.branchName,
      value: item.clubBranchId, // Use actual clubBranchId
      description: item.contactUsViewModel.address
    }));
    // Only show "all branches" option if there are multiple branches
    const allBranchesOption =
      x.length > 1
        ? [
            {
              label: t('credits.allBranches'),
              value: landingData.branchId, // Use main branchId for all branches
              description: t('credits.seeAllCredits')
            }
          ]
        : [];
    return [...allBranchesOption, ...x].filter((branch) =>
      branch.label.includes(searchValue)
    );
  }, [landingData, searchValue, t]);

  useEffect(() => {
    setSelectedSort(sortOptions[0]);
  }, []);

  useEffect(() => {
    // Don't set branch until landingData is loaded
    if (!landingData || landingLoading || branches.length === 0) return;

    if (branchIdParam) {
      // Find branch by clubBranchId from URL
      const branch = branches.find(
        (item) => String(item.value) === branchIdParam
      );
      setSelectedBranch(branch || branches[0]);
    } else {
      // Default to first branch in the list
      setSelectedBranch(branches[0]);
    }
  }, [branchIdParam, branches, landingData, landingLoading]);

  return (
    <>
      <ActionSheet
        open={openSortActionSheet}
        id={'sortList'}
        footer={false}
        onDismiss={() => setOpenSortActionSheet(false)}>
        <StyledDiv direction="rtl">
          <StyledDiv color="normalText" fontSize={4} mb={8}>
            <Icon name="sorting" fontSize={10} ml={5} color="normalText" />
            {t('credits.sortBy')}
          </StyledDiv>
          <RadioGroup
            layout="vertical"
            options={sortOptions}
            defaultCheckedRadio={selectedSort}
            onChange={(value) => {
              setDataLength(10);
              setSelectedSort(value);
              setOpenSortActionSheet(false);
            }}
          />
        </StyledDiv>
      </ActionSheet>
      {landingData?.clubLinkBranchInfoViewModels?.length > 1 &&
        selectedBranch && (
          <ActionSheet
            open={openBranchesActionSheet}
            id={'branches'}
            footer={false}
            onDismiss={() => setOpenBranchesActionSheet(false)}>
            <StyledDiv direction="rtl">
              <SearchInput
                searchValue={searchValue}
                setSearchValue={setSearchValue}
              />

              <RadioGroup
                layout="vertical"
                options={branches}
                defaultCheckedRadio={selectedBranch}
                onChange={handleBranchChange}
              />
            </StyledDiv>
          </ActionSheet>
        )}
      <StyledDiv pt={12} px={8}>
        <StyledDiv
          display="flex"
          gap={10}
          alignItems="center"
          mb={9}
          direction="rtl">
          {landingData?.clubLinkBranchInfoViewModels?.length > 1 && (
            <StyledFilter onClick={() => setOpenBranchesActionSheet(true)}>
              <Icon name="control" fontSize={10} ml={5} color="normalText" />
              <StyledSpan>{selectedBranch?.label}</StyledSpan>
            </StyledFilter>
          )}
          <StyledFilter onClick={() => setOpenSortActionSheet(true)}>
            <Icon name="sorting" fontSize={10} ml={5} color="normalText" />
            <StyledSpan>{selectedSort?.label}</StyledSpan>
          </StyledFilter>
        </StyledDiv>

        <CreditsList
          branchId={selectedBranch?.value}
          sortOrder={selectedSort?.value}
        />
      </StyledDiv>
    </>
  );
};

export default Credits;
